jQuery(function ($) {
	setTimeout(function () {
		$('.home .gc-hero .gc-heading__title').fadeOut(function() {
			$(this).html('Navigating<br> the next').fadeIn();
		});
	}, 4000);
});